module.exports = __webpack_public_path__ + "static/media/README.d5cd78e3.md";